import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import {
  MatButtonModule,
  MatDialogModule,
  MatIconModule,
  MatTooltipModule
} from '@angular/material';
import { PreviewAuditPictureDialogComponent } from './preview-audit-picture-dialog.component';
import { EditAuditPictureItemDialogModule } from '../edit-audit-picture-item-dialog/edit-audit-picture-item-dialog.module';

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatTooltipModule,
    EditAuditPictureItemDialogModule
  ],
  declarations: [PreviewAuditPictureDialogComponent],
  entryComponents: [PreviewAuditPictureDialogComponent],
  exports: [PreviewAuditPictureDialogComponent]
})
export class PreviewAuditPictureDialogModule {}



// WEBPACK FOOTER //
// /home/web_clients/qualicheck.fr/preprod/erp/src/app/core/dialogs/preview-audit-picture-dialog/preview-audit-picture-dialog.module.ts